var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { linkedShape } from '../package.js';
import { Place } from './Place.js';
import { schema } from '../ontologies/schema.js';
let AdministrativeArea = class AdministrativeArea extends Place {
};
AdministrativeArea.targetClass = schema.AdministrativeArea;
AdministrativeArea = __decorate([
    linkedShape({
        description: 'A geographic or political area, e.g., country, region, city. Often linked to addresses, organizations, or events. (location, region, jurisdiction)',
    })
], AdministrativeArea);
export { AdministrativeArea };
//# sourceMappingURL=AdministrativeArea.js.map